export enum SortTypes {
  Id = 'Id',
  Name = 'Name',
  Description = 'Description',
  updatedAt = 'Creation',
}